import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { hierarchyContext } from "../CompanyHierarchyContext.js";
import { tryFind, collect, tryHead } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Links_GroupPath } from "../Utils.js";
import { createObj, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_Shortcut_Z74A6BA73 } from "../Components/Shortcut.js";
import ReceiptLong from "@mui/icons-material/ReceiptLong";
import Build from "@mui/icons-material/Build";
import Phone from "@mui/icons-material/Phone";
import People from "@mui/icons-material/People";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { MuiXHelpers_createElement } from "../fable_modules/Feliz.MuiX.DatePickers.6.9.2-alpha.6/Mui.fs.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Components_ActivityCalendar_Z2E686B84 } from "../Components/Activities/ActivityCalendar.js";
import { Tickets_StatusCard_Z2E686B84 } from "../Components/Tickets/StatusCard.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Components_OrderStatusCard_Z2E686B84 } from "../Components/OrderStatusCard.js";
import { Tickets_WarrantyStatusCard_Z2E686B84 } from "../Components/Tickets/WarantyStatusCard.js";

export function View(viewInputProps) {
    let elems_12, elems_1, elems, elems_11, elems_4, elems_3, value_41, elems_2, elems_10, elems_9;
    const groupId = viewInputProps.groupId;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const firstCustomerInGroup = tryHead(collect((group) => {
        if (group.Id === groupId) {
            return group.Customers;
        }
        else {
            return [];
        }
    }, hierarchy.Groups));
    const patternInput = defaultArg(map((s) => [s.IsSuperAdmin ? true : s.IsAdmin, s.IsPtg, s.TicketAccess], ctx.Session), [false, false, false]);
    const isPTG = patternInput[1];
    const isAdmin = patternInput[0];
    const hasTicketAccess = patternInput[2];
    const isCustomer = !isAdmin && !isPTG;
    const groupOpt = tryFind((group_1) => (group_1.Id === groupId), hierarchy.Groups);
    if (hierarchy.GroupsFetched) {
        if (groupOpt == null) {
            RouterModule_nav(singleton(""), 1, 1);
        }
    }
    const groupPageUrl = (arg) => RouterModule_encodeParts(ofArray(Links_GroupPath(groupId, arg)), 1);
    const hasCustomerWithActivityPlan = defaultArg(map((group_2) => group_2.Customers.some((_arg) => _arg.EnableServices), groupOpt), false);
    const contactUrl = (firstCustomerInGroup != null) ? RouterModule_encodeParts(ofArray(["contact", int32ToString(firstCustomerInGroup.Id)]), 1) : RouterModule_encodeParts(singleton("contact"), 1);
    const orderServiceHref = groupPageUrl(isCustomer ? "tickets" : "activity-plan");
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 40 + "px",
    }], (elems_12 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.WhatDoYouWantToDo")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 30 + "px",
    }], (elems = toList(delay(() => append((isAdmin ? true : isPTG) ? singleton_1(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.SeeMy"),
        lower: ctx.Locale.t("CustomerSite.Overview.Invoice"),
        href: groupPageUrl("economy"),
        icon: (props_1) => {
            const props_3 = createObj(props_1);
            return react.createElement(ReceiptLong, props_3);
        },
    })) : empty(), delay(() => append((hasCustomerWithActivityPlan && (!isCustomer ? true : hasTicketAccess)) ? singleton_1(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("Order"),
        lower: ctx.Locale.t("CustomerSite.Overview.service"),
        href: orderServiceHref,
        icon: (props_4) => {
            const props_6 = createObj(props_4);
            return react.createElement(Build, props_6);
        },
    })) : empty(), delay(() => append(singleton_1(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("Pages.Contact"),
        lower: ctx.Locale.t("PTG"),
        href: RouterModule_encodeParts(singleton(contactUrl), 1),
        icon: (props_7) => {
            const props_9 = createObj(props_7);
            return react.createElement(Phone, props_9);
        },
    })), delay(() => singleton_1(createElement(Components_Shortcut_Z74A6BA73, {
        upper: ctx.Locale.t("CustomerSite.Overview.Help"),
        lower: ctx.Locale.t("CustomerSite.Overview.Kundeweb"),
        href: RouterModule_encodeParts(singleton("helpdesk"), 1),
        icon: (props_10) => {
            const props_12 = createObj(props_10);
            return react.createElement(People, props_12);
        },
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 40 + "px",
    }], (elems_11 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_4 = [MuiHelpers_createElement(Typography, [["sx", {
        maxWidth: 320 + "px",
    }], ["variant", "h3"], ["children", ctx.Locale.t("CustomerSite.Overview.UpcomingEvents")]]), createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {}], (elems_3 = [MuiXHelpers_createElement(LocalizationProvider, [(value_41 = AdapterDateFns, ["dateAdapter", value_41]), (elems_2 = [createElement(Components_ActivityCalendar_Z2E686B84, {
        groupId: groupId,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_10 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Ticket.Status.Status")]]), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 15 + "px",
    }], (elems_9 = toList(delay(() => {
        let elems_5;
        return append(hasTicketAccess ? singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 15 + "px",
            minWidth: 185 + "px",
        }], (elems_5 = [createElement(Tickets_StatusCard_Z2E686B84, {
            groupId: groupId,
        }), createElement(Components_Button_Z1043B8E, {
            text: ctx.Locale.t("CustomerSite.Overview.TicketOverview"),
            onClick: (_arg_1) => {
                RouterModule_nav(ofArray(["group", int32ToString(groupId), "tickets"]), 1, 1);
            },
            startIcon: (props_20) => {
                const props_22 = createObj(props_20);
                return react.createElement(ArrowForward, props_22);
            },
            small: true,
            sx: some({
                alignSelf: "flex-end",
            }),
        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
            let elems_7, elems_6;
            return append(singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                display: "flex",
                flexDirection: "column",
                gap: 15 + "px",
                minWidth: 185 + "px",
            }], (elems_7 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Orders.Orders")]]), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 10 + "px",
            }], (elems_6 = [createElement(Components_OrderStatusCard_Z2E686B84, {
                groupId: groupId,
            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let elems_8;
                return singleton_1(createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 15 + "px",
                    minWidth: 185 + "px",
                }], (elems_8 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("CustomerSite.Overview.DeviationWarranties")]]), createElement(Tickets_WarrantyStatusCard_Z2E686B84, {
                    groupId: groupId,
                })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

